componentRegistryInstance.register('integer', 'edit', 'hrd.components.form.IntegerComponent');
componentRegistryInstance.register('integer', 'read', 'hrd.components.form.IntegerComponent');

hrd.components.form.IntegerComponent = hrd.components.form.AbstractNumericComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.IntegerComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		var seps = this.utils().number().separators();
		var opts = {
			aSep: '', // removed grouping separator for integers...
			aDec: seps.decimal,
			vMax: '2147483647', //java 'MAX_INT'
			mDec: '0'
		}
		if (field.data('minValue') !== undefined) {
			opts.vMin = '' + field.data('minValue');
		}
		if (field.data('maxValue') !== undefined) {
			opts.vMax = '' + field.data('maxValue');
		}
		field.autoNumeric('init', opts);
		field.addClass('right-align');
	},
	initalizeComponentWithUndefined: function(field) {
		field.autoNumeric('set', '0');
	}
});